
import Vue from 'vue';
import FlowShell from '@/components/generic/FlowShell.vue';
export default Vue.extend({
  name: 'Flow',
  data: () => ({
  }),
  components: {
    FlowShell,
  },
});
